import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";

import { lastValueFrom, Observable, of } from 'rxjs';
import * as Sentry from "@sentry/angular";
import { Router } from '@angular/router';
import { SupabaseService } from './supabase.service';
import { ProfilService } from './profil-service';
import { DonneesBaseService } from './donnees-base-service';
import { HealthService } from './health.service';
import { ProfilEntite } from '../entites/profil';

@Injectable({ providedIn: 'root' })
export class InitialisationService {

 

  constructor(
    private sdb: DonneesBaseService,
    private profilService: ProfilService,
    private http: HttpClient,
    public router: Router,
    private supabaseService: SupabaseService,
    private healthService: HealthService) { }


  public async initialiser(): Promise<void> {

    console.log('Début Initialisation');

    var user = await lastValueFrom(this.supabaseService.userAuthenticated$)
    if (user === null || user === undefined) return;
    try {
      var profil = this.profilService.Profil() ?? await lastValueFrom(this.profilService.ObtenirProfil())
      try {
        Sentry.setUser({
          email: profil.employe.courriel,
          username: profil.employe.noEmploye
        })
      } catch (error) {
        console.log('Init: Set User Sentry Erreur')
      }
    } catch (error) {
      console.log('Init: Obtenir Profil SIHC Erreur')
      console.log(error)
      this.router.navigateByUrl('error');
    }

    if (!this.sdb.initialized) {
      try {
        await this.sdb.initialiser();
      } catch (error) {
        console.log('Init: Init SDB Erreur')
        console.log(error)
        this.router.navigateByUrl('error');
      }
      console.log('Init: Init SDB OK')
    } 

    console.log(profil);
  }
}
